









































import SeletorDeGenero from '@/components/produto/SeletorDeGenero.vue'
import { Component, Vue } from 'vue-property-decorator'
import SeletorDeEstacao from '@/components/produto/SeletorDeEstacao.vue'
import SeletorDeCategoria from '@/components/produto/SeletorDeCategoria.vue'
import { Estacao, Genero } from '@/models'

export interface FiltrosDaVitrine {
	tamanho: string
	cor: string
	categoria: string | null
	genero: Genero | null
	estacao: Estacao | null
	produtoSimilar: string
	badges?: string[]
}

@Component({
	components: {
		SeletorDeCategoria,
		SeletorDeGenero,
		SeletorDeEstacao,
	},
})
export default class DialogoDeFiltrosDaVitrineVirtual extends Vue {
	mostra = false

	filtros: FiltrosDaVitrine = {
		tamanho: '',
		cor: '',
		categoria: null,
		genero: null,
		estacao: null,
		produtoSimilar: '',
		badges: [],
	}

	generos = [
		'Masculino',
		'Feminino',
		'Unissex',
		'Infantil',
	]

	estacoes = [
		'Primavera',
		'Verão',
		'Outono',
		'Inverno',
	]

	mostrar(filtrosAtivos?: Partial<FiltrosDaVitrine>) {
		if (filtrosAtivos) {
			this.filtros = {
				...this.filtros,
				...filtrosAtivos,
			}
		}

		this.mostra = true
	}

	aplicarFiltros() {
		this.$emit('aplicar-filtros', { ...this.filtros })
		this.mostra = false
	}

	limparFiltros() {
		this.filtros = {
			tamanho: '',
			cor: '',
			categoria: null,
			genero: null,
			estacao: null,
			produtoSimilar: '',
			badges: [],
		}

		this.$emit('limpar')
		this.mostra = false
	}
}
